<!-- Zweck: Stellt die HTML-Struktur für app notification entry component im Frontend bereit. -->
<table (click)="navigateSeen($event)" class="clickable notentry">
  <tr>
    <td class="icon" rowspan="2">
      <svg-icon>{{getIcon()}}</svg-icon>
    </td>
    <td (click)="navigateSeen($event)" class="title">
      {{getLabel()}}
      <div style="text-align: right; font-size: 11px; opacity: 0.6;">
        @if (show_seen) {
          <span>Gesendet: </span>
          }{{notification.dat_insert}}
        </div>
        @if (show_seen && notification.seen) {
          <div style="text-align: right; font-size: 11px;">
            <svg-icon color="green">check</svg-icon> Gesehen: {{notification.dat_seen}}
          </div>
        }
      </td>
      <td class="action" rowspan="2">
        @if (show_dismissable && notification.dismissable) {
          <button (click)="setSeen($event);" mat-icon-button>
            <svg-icon>error-bk</svg-icon>
          </button>
        }
      </td>
    </tr>
    <tr>
      <td [innerHtml]="getText() | nl2br | raw" class="payload"></td>
    </tr>
  </table>
